<div class="c-portlet o-block u-width-100p _u-width-100p u-bg-primary {{ sectionclass }}">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div>
		<a
			href="#"
			class="datatable_download_icon"
			*ngIf="hasData && downloadConfiguration && downloadConfiguration.enableDownload"
			(click)="downloadCSV()"
			target="_blank"
		>
			<img class="downloadIcon" src="../../../../../assets/creative-assets/download.svg" />
		</a>
	</div>
	<div *ngIf="hasData">
		<div class="unique_reach_frequency">
			<div
				class="date-range-banner date-range-banner-above-title"
				*ngIf="campaignCarouselItem.showBanner"
				style="display: none"
			>
				<div class="banner-content">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="14"
						height="14"
						viewBox="0 0 14 14"
						fill="none"
						style="margin-right: 8px; flex-shrink: 0"
					>
						<path
							d="M5.83333 7C5.83333 6.72386 6.05719 6.5 6.33333 6.5H7C7.27614 6.5 7.5 6.72386 7.5 7V10.3333C7.5 10.6095 7.27614 10.8333 7 10.8333C6.72386 10.8333 6.5 10.6095 6.5 10.3333V7.5H6.33333C6.05719 7.5 5.83333 7.27614 5.83333 7Z"
							fill="#00AAFF"
						/>
						<path
							d="M6.83267 3.83333C6.46583 3.83333 6.16497 4.13099 6.16667 4.50181C6.16765 4.86912 6.4658 5.16667 6.83333 5.16667C7.20148 5.16667 7.5 4.86814 7.5 4.5C7.5 4.13056 7.20017 3.83333 6.83267 3.83333Z"
							fill="#00AAFF"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M0.5 7C0.5 3.40986 3.40986 0.5 7 0.5C10.5901 0.5 13.5 3.40986 13.5 7C13.5 10.5901 10.5901 13.5 7 13.5C3.40986 13.5 0.5 10.5901 0.5 7ZM7 1.5C3.96214 1.5 1.5 3.96214 1.5 7C1.5 10.0379 3.96214 12.5 7 12.5C10.0379 12.5 12.5 10.0379 12.5 7C12.5 3.96214 10.0379 1.5 7 1.5Z"
							fill="#00AAFF"
						/>
					</svg>
					<div class="banner-text">
						Some reach and frequency values may be incomplete due to historical data limits (only past 2 years + 1
						quarter available)
					</div>
				</div>
			</div>
			<div class="campaigns-toggle">
				<div class="creative-card-name">
					<h2 id="creativeName" class="creativeNameDropdown"></h2>
					<ng-select
						[items]="campaignsList"
						bindLabel="name"
						[title]="campaignCarouselItem.name"
						[(ngModel)]="campaignCarouselItem.name"
						(change)="changeCampaignData($event)"
					>
					</ng-select>
				</div>
				<div class="header">Trailing 30-day Household Reach & Frequency</div>
				<div class="lifetime-chart">
					<div class="date-range-banner" *ngIf="campaignCarouselItem.showBanner">
						<div class="banner-content">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="14"
								height="14"
								viewBox="0 0 14 14"
								fill="none"
								style="margin-right: 8px; flex-shrink: 0"
							>
								<path
									d="M5.83333 7C5.83333 6.72386 6.05719 6.5 6.33333 6.5H7C7.27614 6.5 7.5 6.72386 7.5 7V10.3333C7.5 10.6095 7.27614 10.8333 7 10.8333C6.72386 10.8333 6.5 10.6095 6.5 10.3333V7.5H6.33333C6.05719 7.5 5.83333 7.27614 5.83333 7Z"
									fill="#00AAFF"
								/>
								<path
									d="M6.83267 3.83333C6.46583 3.83333 6.16497 4.13099 6.16667 4.50181C6.16765 4.86912 6.4658 5.16667 6.83333 5.16667C7.20148 5.16667 7.5 4.86814 7.5 4.5C7.5 4.13056 7.20017 3.83333 6.83267 3.83333Z"
									fill="#00AAFF"
								/>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.5 7C0.5 3.40986 3.40986 0.5 7 0.5C10.5901 0.5 13.5 3.40986 13.5 7C13.5 10.5901 10.5901 13.5 7 13.5C3.40986 13.5 0.5 10.5901 0.5 7ZM7 1.5C3.96214 1.5 1.5 3.96214 1.5 7C1.5 10.0379 3.96214 12.5 7 12.5C10.0379 12.5 12.5 10.0379 12.5 7C12.5 3.96214 10.0379 1.5 7 1.5Z"
									fill="#00AAFF"
								/>
							</svg>
							<div class="banner-text">
								Some reach and frequency values may be incomplete due to historical data limits (only past 2 years + 1
								quarter available)
							</div>
						</div>
					</div>
					<div *ngIf="campaignCarouselItem.showChart; else elseBlockHideChart" class="" style="min-height: 200px">
						<app-chart
							class="individual-chart"
							[setcolor]="customchartconfiguration.setGraphBackgroundColor"
							[chartData]="campaignCarouselItem"
						></app-chart>
					</div>
					<ng-template #elseBlockHideChart>
						<div class="individual-chart">
							<p class="no-data-selected-date">No Data Available</p>
						</div>
					</ng-template>
				</div>
			</div>
			<div class="campaign-data">
				<div class="lifetime-average">
					<div class="lifetime-average-title">Lifetime Campaign Average</div>

					<div *ngFor="let avg of campaignCarouselItem.averageLifetimes">
						<div class="lifetime-average-metric">
							<div class="metric-value" [ngClass]="{ 'normal-font-weight': avg.isNonZeroValue }">
								{{ avg.parameterValue }}
							</div>
							<div class="metric-title">
								{{ avg.parameterName }}
							</div>
						</div>
					</div>
				</div>
				<!-- check buttons section header -->
				<div class="checkbox-section-name" *ngIf="seriesviewconfiguration.checkboxGroupSectionName">
					{{ seriesviewconfiguration.checkboxGroupSectionName }}
				</div>
				<!-- checkboxes -->
				<div class="checkbox-group-container" *ngIf="seriesviewconfiguration.checkboxButtons">
					<span class="span-checkbox-container">
						<label
							for="{{ nameSpace }}-checkbox-{{ button.seriesId }}"
							class="checkbox-container {{ button.color }}"
							*ngFor="let button of seriesviewconfiguration.checkboxButtons"
						>
							<input
								type="checkbox"
								id="{{ nameSpace }}-checkbox-{{ button.seriesId }}"
								value="{{ button.seriesId }}"
								[checked]="button.visible"
								(change)="toggleSeriesVisiblityByCheckbox($event.target.value)"
							/>
							<span class="checkbox-button"></span>
							<span class="checkbox-text">{{ button.displayName }}</span>
						</label>
						<div class="legendTooltip-container">
							<div class="tooltipText">
								The number of unique households exposed to the ad at least once in the past 30 days (a rolling 30 day
								window).
							</div>
							<div class="tooltip-pointer"></div>
						</div>
					</span>
				</div>

				<!-- radion buttons with sections -->
				<div class="section-name" *ngIf="seriesviewconfiguration.radioGroupSectionName">
					{{ seriesviewconfiguration.radioGroupSectionName }}
				</div>
				<div
					class="radio-container {{ radioButton.color }}"
					*ngFor="let radioButton of seriesviewconfiguration['radioButtonGroup']; let radioButtonId = index"
				>
					<span class="span-checkbox-container">
						<label for="{{ nameSpace }}-radio-button-{{ radioButtonId }}">
							<input
								id="{{ nameSpace }}-radio-button-{{ radioButtonId }}"
								type="radio"
								name="{{ nameSpace }}-button-group"
								[value]="radioButtonId"
								[checked]="selectedRadioButtonId === radioButtonId"
								(change)="updateSeriesVisibilityByRadioButton($event.target.value)"
							/>
							<span class="radio-text">{{ radioButton.displayName }}</span>
						</label>
						<div class="legendTooltip-container">
							<div class="tooltipText">
								The average number of times a unique household has seen the ad in the past 30 days (a rolling 30 day
								window).
							</div>
							<div class="tooltip-pointer"></div>
						</div>
					</span>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="!hasData" class="no-reach-frequency">
		<div class="no-data-text">No Data Available</div>
	</div>
</div>
